// Copyright aptihealth, inc. 2019 All Rights Reserved

import a5ScreeningRequests from "./a5Screening";
import adminRequests from "./admin";
import authRequests from "./auth";
import featureFlagRequests from "./featureFlag";
import messagingRequests from "./messaging";
import metricsRequests from "./metrics";
import obfuscationRequests from "./obfuscation";
import patientRequests from "./patient";
import { patientRequestsTyped } from "./patientTyped";
import paymentRequests from "./payment";
import providerRequests from "./provider";
import publicRequests from "./public";
import { publicRequestsTyped } from "./publicTyped";
import scheduleRequests from "./schedule";
import searchRequests from "./search";
import sharedRequests from "./shared";
import trackingRequests from "./tracking";
import workflowRequests from "./workflow";
import workingHourRequests from "./workingHours";
import { carePlanRequests } from "./care_plan";
import { providerRequestsTyped } from "./providerTyped";

export const api = {
  a5Screening: a5ScreeningRequests,
  admin: adminRequests,
  auth: authRequests,
  carePlan: carePlanRequests,
  featureFlag: featureFlagRequests,
  messaging: messagingRequests,
  metrics: metricsRequests,
  obfuscation: obfuscationRequests,
  patient: patientRequests,
  patientTyped: patientRequestsTyped,
  payment: paymentRequests,
  provider: providerRequests,
  providerTyped: providerRequestsTyped,
  public: publicRequests,
  publicTyped: publicRequestsTyped,
  schedule: scheduleRequests,
  search: searchRequests,
  shared: sharedRequests,
  tracking: trackingRequests,
  workflow: workflowRequests,
  workingHours: workingHourRequests,
};
